import { Categories } from "../api.dtos";

export const girlCategories = [
  {
    category: Categories.NICE_LADIES,
    tKey: "common:girlCategories.niceLadies"
  },
  {
    category: Categories.BAD_LADIES,
    tKey: "common:girlCategories.badLadies"
  },
  {
    category: Categories.SECRETARY_TEACHER,
    tKey: "common:girlCategories.secretaryTeacher"
  },
  {
    category: Categories.BUSINESSWOMAN,
    tKey: "common:girlCategories.businesswoman"
  },
  {
    category: Categories.SCIENCE_FICTION_MOVIES,
    tKey: "common:girlCategories.scienceFictionMovies"
  }
];

export const getTKeyGirlCategory = (category: string) => {
  return girlCategories.find((item) => item.category === category)?.tKey;
};
